// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// Component
export const IconFinger = ({ width, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 54.987 53.862"
      width={width}
      {...props}
    >
      <path
        className="a"
        fill="#5badfa"
        d="M54.17,121.112a.989.989,0,0,0,1.093-.615,21.1,21.1,0,0,1,3.9-7.568.887.887,0,0,0-1.383-1.111,22.869,22.869,0,0,0-4.224,8.2A.866.866,0,0,0,54.17,121.112Zm0,0"
        transform="translate(-52.752 -103.199)"
      />
      <path
        className="a"
        fill="#5badfa"
        d="M149.579,65.351a.887.887,0,0,0,.887-.887,23.051,23.051,0,0,0-38.044-17.509.887.887,0,1,0,1.154,1.347,21.277,21.277,0,0,1,35.116,16.162A.887.887,0,0,0,149.579,65.351Zm0,0"
        transform="translate(-104.413 -41.414)"
      />
      <path
        className="a"
        fill="#5badfa"
        d="M87.371,98.388c.024,0,.049,0,.073,0a.887.887,0,0,0,.812-.956,25.9,25.9,0,0,0-3.088-10.4A16.693,16.693,0,0,0,78.992,80.7a17.588,17.588,0,0,0-8.943-2.433A18.491,18.491,0,0,0,52.258,91.722c-.077.28-.17.678-.274,1.182a1.819,1.819,0,0,1-1.549,1.439c-.743.094-1.594.16-2.53.2a.887.887,0,0,0,.071,1.772c.986-.039,1.888-.11,2.681-.21a3.594,3.594,0,0,0,3.064-2.838c.1-.467.181-.828.247-1.069A16.712,16.712,0,0,1,70.049,80.043a15.812,15.812,0,0,1,8.041,2.186,14.918,14.918,0,0,1,5.521,5.65,24.129,24.129,0,0,1,2.876,9.693A.887.887,0,0,0,87.371,98.388Zm0,0"
        transform="translate(-47.047 -73.91)"
      />
      <path
        className="a"
        fill="#5badfa"
        d="M319.114,162.687h.025a.887.887,0,0,0,.886-.862,13.962,13.962,0,0,0-.072-2.068,14.152,14.152,0,0,0-4.085-9.692.887.887,0,1,0-1.264,1.244,12.384,12.384,0,0,1,3.577,8.526.84.84,0,0,0,.007.1,12,12,0,0,1,.064,1.837A.887.887,0,0,0,319.114,162.687Zm0,0"
        transform="translate(-282.735 -136.982)"
      />
      <path
        className="a"
        fill="#5badfa"
        d="M47.931,133.911l.121,0a25,25,0,0,0,6.723-1.025,4.207,4.207,0,0,0,2.852-3.705c.025-.334.066-.666.121-.985a12.443,12.443,0,0,1,18.024-8.909.887.887,0,0,0,.824-1.571A14.226,14.226,0,0,0,56,127.89c-.065.376-.112.764-.141,1.154a2.437,2.437,0,0,1-1.642,2.154,22.932,22.932,0,0,1-6.233.935l-.121,0a.887.887,0,0,0,.034,1.773Zm0,0"
        transform="translate(-47.01 -107.262)"
      />
      <path
        className="a"
        fill="#5badfa"
        d="M235.062,413.888a23.243,23.243,0,0,1-2.888,1.512.887.887,0,1,0,.712,1.625,24.935,24.935,0,0,0,3.109-1.628.887.887,0,1,0-.933-1.508Zm0,0"
        transform="translate(-209.808 -369.723)"
      />
      <path
        className="a"
        fill="#5badfa"
        d="M81.091,166.477a.888.888,0,0,0,.974-.79,19.363,19.363,0,0,0,.058-3.78,9.976,9.976,0,0,0-19.806-1.652,9.281,9.281,0,0,0-.1,2.115,3.314,3.314,0,0,1-.964,2.421c-1.2,1.323-4.082,2.958-10.971,3.227a.887.887,0,0,0,.034,1.773h.035c6.025-.235,10.134-1.516,12.215-3.806a5.071,5.071,0,0,0,1.421-3.715,7.513,7.513,0,0,1,.075-1.712,8.2,8.2,0,0,1,16.284,1.4.974.974,0,0,0,.006.1A17.489,17.489,0,0,1,80.3,165.5.887.887,0,0,0,81.091,166.477Zm0,0"
        transform="translate(-49.145 -138.904)"
      />
      <path
        className="a"
        fill="#5badfa"
        d="M168.425,366a.887.887,0,0,0-1.252-.077,23.339,23.339,0,0,1-11.763,5.163.887.887,0,0,0,.148,1.761.874.874,0,0,0,.15-.013,25.065,25.065,0,0,0,12.639-5.583A.887.887,0,0,0,168.425,366Zm0,0"
        transform="translate(-141.941 -327.35)"
      />
      <path
        className="a"
        fill="#5badfa"
        d="M87.066,191.851a5.962,5.962,0,0,0-11.836-.982,5.307,5.307,0,0,0-.046,1.2,7.3,7.3,0,0,1-2,5.349c-1.954,2.152-5.044,3.511-9.447,4.156-1.178.091-2.3.187-3.343.285a.887.887,0,0,0,.166,1.766c1.04-.1,2.165-.194,3.343-.285l.059-.006c4.842-.7,8.288-2.25,10.534-4.723a9.061,9.061,0,0,0,2.457-6.643,3.733,3.733,0,0,1,.023-.8,4.188,4.188,0,0,1,8.314.716c0,.025,0,.05,0,.075.006.065.506,6.525-3.544,11.015-2.242,2.486-7.511,5.42-15.575,6.2a.887.887,0,0,0,.084,1.77.787.787,0,0,0,.087,0c7.169-.694,13.576-3.292,16.721-6.778C87.505,199.248,87.114,192.488,87.066,191.851Zm0,0"
        transform="translate(-58.103 -168.836)"
      />
      <path
        className="a"
        fill="#5badfa"
        d="M89.558,245.724a23.6,23.6,0,0,1-3.783,1.263,29.143,29.143,0,0,1-5.472.778.887.887,0,0,0,.043,1.773h.045a30.918,30.918,0,0,0,5.806-.827,25.418,25.418,0,0,0,4.067-1.359A20.641,20.641,0,0,0,96.62,243.1c1.855-1.839,2.842-4.8,2.78-8.336,0-.03,0-.056,0-.076a.887.887,0,0,0-1.512-.7.986.986,0,0,0-.26.8c.054,3.048-.747,5.55-2.255,7.045A18.888,18.888,0,0,1,89.558,245.724Zm0,0"
        transform="translate(-75.622 -210.986)"
      />
      <path
        className="b"
        fill="#1351aa"
        d="M296.944,268.3a13.515,13.515,0,1,0,13.515,13.515A13.53,13.53,0,0,0,296.944,268.3Zm0,25.256a11.741,11.741,0,1,1,11.741-11.741A11.754,11.754,0,0,1,296.944,293.56Zm0,0"
        transform="translate(-255.472 -241.473)"
      />
      <path
        className="a"
        fill="#5badfa"
        d="M34.218,54.8"
        transform="translate(-5.559 -4.896)"
      />
      <path
        className="b"
        fill="#1351aa"
        d="M353.436,310.583h-.183v-1.561a5.054,5.054,0,0,0-10.107,0v1.561h-.183a1.406,1.406,0,0,0-1.4,1.4v7.49a1.406,1.406,0,0,0,1.4,1.4h10.473a1.406,1.406,0,0,0,1.4-1.4v-7.49A1.406,1.406,0,0,0,353.436,310.583Zm-8.516-1.561a3.279,3.279,0,0,1,6.559,0v1.561H344.92Zm8.147,10.086h-9.734v-6.751h9.734Zm0,0"
        transform="translate(-306.727 -272.92)"
      />
    </svg>
  )
}

IconFinger.propTypes = {
  width: PropTypes.string,
}

IconFinger.defaultProps = {
  width: '45px',
}

export default IconFinger
